/* eslint-disable @typescript-eslint/no-explicit-any */
import $api from '../config/api'

export const getAllLinks = async () => {
  const response = await $api.get('/links')
  return response.data
}

export const getLinkById = async (id: string) => {
  const response = await $api.get(`/links/${id}`)
  return response.data
}

export const createLink = async (reqData: CreateLinkData) => {
  const response = await $api.post('/links', reqData)
  return response
}

export const updateLink = async (reqData: updateLinkData, id: string) => {
  const response = await $api.patch(`/links/${id}`, reqData)
  return response.data
}

export const deleteLink = async (id: string) => {
  const response = await $api.delete(`/links/${id}`)
  return response.data
}

export const changeLinkOrder = async (reqData: any) => {
  const response = await $api.put('/links/order', reqData)
  return response.data
}
